import script from "./TheUserZone.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheUserZone.vue?vue&type=script&lang=ts&setup=true"

import "./TheUserZone.vue?vue&type=style&index=0&id=8c64d20c&lang=css"

const __exports__ = script;

export default __exports__